import 'regenerator-runtime/runtime'

import { HTMLControllerRegistry } from '../utils/html-controller.js'

import { CookieBanner } from '../controllers/cookie-banner.js'
import { TopNav, TopNavButton } from '../controllers/top-nav.js'

const registry = new HTMLControllerRegistry()

registry.define('CookieBanner', CookieBanner)
registry.define('TopNav', TopNav)
registry.define('TopNavButton', TopNavButton)

registry.mount()
